export default __webpack_public_path__ + "static/media/burger-icon.7fc31dfc.svg";